import * as DKFDS from 'dkfds';
import $ from 'jquery';

function acknowledgeNotification(notificationId, event) {
    $.ajax('/acknowledge-notifications', {
        data: {ids: notificationId}
    }).done(function () {
        const notificationNumberSpan = $('.inboxBadge');
        const currentNotifications = parseInt(notificationNumberSpan.html(), 10);
        const updatedNotifications = currentNotifications - 1;
        if (updatedNotifications > 0) {
            notificationNumberSpan.html(updatedNotifications);
            notificationNumberSpan.parent().find('.tooltip').html(`Der er ${updatedNotifications} ulæste notifikationer`);
        } else {
            notificationNumberSpan.html('');
            notificationNumberSpan.parent().find('.tooltip').html('Der er ingen ulæste notifikationer');
        }

        $(event.target || event.srcElement).closest('.card').hide('slow', function () {
            $(this).remove();
        });
    });
}

$('#messageNotificationsModal a[data-msg]').on('click', function () {
    if ($('.receipt').length > 0) return true;
    $('#topMenuModalText').html(this.dataset.msg);
    $('#topMenuModalTarget')
        .attr('href', this.href)
        .off('click')
        .on('click', () => $('#topMenuLoading').show());
    new DKFDS.Modal(document.getElementById('messageNotificationsModal')).hide();
    new DKFDS.Modal(document.getElementById('topMenuModal')).show();
    return false;
});

$('#messageNotificationsModal button[data-id]').on('click', function (event) {
    acknowledgeNotification(this.dataset.id, event);
});